import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  p: (p) => p.spacing(2, 1.5),
};

export const rightBox: SxStyle = {
  alignSelf: 'stretch',
  justifyContent: 'space-between',
};

export const planPeriod: SxStyle = {
  fontSize: (p) => p.typography.body4.fontSize,
  fontWeight: (p) => p.typography.fontWeightRegular,
  color: (p) => p.palette.grey[600],
};

export const intervalBox: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  alignSelf: 'end',
  borderRadius: (p) => p.spacing(0.5),
  p: (p) => p.spacing(0.5),
  gap: (p) => p.spacing(0.5),
  borderWidth: '1px',
  borderColor: (p) => p.palette.grey[300],
  borderStyle: 'solid',
};

export const upcoming: SxStyle = {
  borderColor: (p) => p.palette.warning[600],
  borderStyle: 'solid',
  borderWidth: '1px',
  backgroundColor: (p) => p.palette.warning[50],
  padding: (p) => p.spacing(0.5, 1),
  borderRadius: (p) => p.spacing(0.5),
};
